'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { SvgIcon } from '@s7/base';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const MilesSemibold = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ jsx(SvgIcon, _extends({
        fill: "none",
        height: 72,
        viewBox: "0 0 72 72",
        width: 72
    }, props, {
        ref: ref,
        children: /*#__PURE__*/ jsx("path", {
            clipRule: "evenodd",
            d: "M23.75 31.0198V53.4014H18.25V41.1514H8V35.6514H18.25V18.6514H24.2901L36 45.107L47.7099 18.6514H53.75V35.6514H64V41.1514H53.75V53.4014H48.25V31.0198L38.5147 53.0144H33.4853L23.75 31.0198Z",
            fill: "currentColor",
            fillRule: "evenodd"
        })
    })));

export { MilesSemibold };
//# sourceMappingURL=MilesSemibold.js.map
